import { css } from '@emotion/react';

export const actionMenuContainerStyles = css`
  display: inline-block;
`;

export const triggerButtonStyles = css`
  background: var(--color-base-white);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background: var(--color-neutral-100);
  }

  &:focus {
    outline: 2px solid var(--color-brand-primary);
    outline-offset: 2px;
  }
`;

export const menuDropdownStyles = css`
  background: var(--color-base-white);
  border: 1px solid var(--color-neutral-200);
  border-radius: var(--spacing-2);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 160px;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-8px);
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out,
    visibility 0.2s;

  &[data-visible='true'] {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
`;

export const menuItemStyles = css`
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-3) var(--spacing-4);
  border: none;
  background: transparent;
  width: 100%;
  text-align: left;
  cursor: pointer;
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
  transition: background-color 0.15s ease-in-out;

  &:first-of-type {
    border-radius: var(--spacing-2) var(--spacing-2) 0 0;
  }

  &:last-of-type {
    border-radius: 0 0 var(--spacing-2) var(--spacing-2);
  }

  &:only-of-type {
    border-radius: var(--spacing-2);
  }

  &:hover {
    background: var(--color-neutral-50);
  }

  &:focus {
    outline: 2px solid var(--color-brand-primary);
    outline-offset: -2px;
  }

  &[data-danger='true'] {
    color: var(--color-error-500);

    &:hover {
      background: var(--color-error-50);
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;

    &:hover {
      background: transparent;
    }
  }
`;

export const menuDividerStyles = css`
  height: 1px;
  background: var(--color-neutral-200);
  margin: var(--spacing-1) 0;
`;
